<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜尋 用戶標籤" @search="searchEvent" :showGj="true">
				<template #left>
					<el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" v-auth="'add'+auth_val">添加用戶標籤</el-button>
				</template>
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="標籤名稱" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜尋標籤名稱"></el-input>
						</el-form-item>
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋</el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>
					</el-form>
				</template>
			</button-search>
		</div>

		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column align="center" prop="id" label="ID" width="100"></el-table-column>
				<el-table-column align="center" prop="name" label="標籤名稱"></el-table-column>
				<el-table-column align="center" prop="msg" label="備註"></el-table-column>

				<el-table-column align="center" prop="create_time" label="創建時間" width="200"></el-table-column>
				<el-table-column prop="id" align="center" width="180" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope.row)">編輯</el-button>
							<el-button @click="deleteItem(scope.row)"  v-auth="'del'+auth_val" size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"  :title="editIndex==-1?'添加用戶標籤':'修改用戶標籤'" :visible.sync="createModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'140px'" :label-position="layout.is_phone?'top':'left'">
				<el-form-item label="標籤名稱" prop="name">
					<el-input type="text" v-model="form.name" placeholder="標籤名稱" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item label="備註" prop="msg">
					<el-input type="textarea" :rows="6" v-model="form.msg" placeholder="備註" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js';
import buttonSearch from '@/components/common/button-search.vue';
export default {
	components: { buttonSearch },
	inject: ['layout','app'],
	mixins: [common],
	data(){
		return {
			rules: {
				name: [{ required: true, message: '名稱不能為空', trigger: 'blur' }],
			},
			createModel: false,
			editIndex: -1,
			from: { name: '' },
			model_title: 'UserLabel',
			auth_val: 'userLabel',
			preUrl: 'data/userLabelList',
			delUrl: 'data/delUserLabel',
			addUrl: 'data/addUserLabel',
			tableData: [],
			form: { id: 0, name: '', msg: '' },
		}
	},
	methods: {
		// 提交
		submit(){
			this.$refs.formEdit.validate(ok => {
				if(!ok) return;
				this.form.id = this.editIndex;
				this.addOrEdit(this.form);
			});
		},
		// 打开弹窗
		openModel(row){
			if(row){
				this.form = { id: row.id, name: row.name, msg: row.msg, status: row.status };
				this.editIndex = row.id;
			}else{
				this.form = { id: 0, name: '', msg: '', status: 1 };
				this.editIndex = -1;
			}
			this.createModel = true;
		},
		// 清空条件
		clearSearch(){
			this.from = { name: '' };
			this.search = '';
			this.getList();
		}
	}
}
</script>

<style>
</style>


